module.exports = __webpack_public_path__ + "img/icon_code.c00a67bc.png";